import { Box, Flex, Text, Button, HStack, Input } from "@chakra-ui/react";
import { X } from "lucide-react";
import { colors } from "@/theme/colors";

export const ACK_TYPE = "__ack__";
export const FORM_ASSIGN_TYPE = "__assign__";

const Select = ({ value, onChange, children, testId, w }) => (
  <Box as="select" value={value} onChange={onChange} data-testid={testId}
    px="3" h="40px" borderRadius="8px" border="1px solid" borderColor={colors.border}
    bg={colors.white} fontSize="sm" color={colors.textPrimary} w={w || "auto"} minW="140px">
    {children}
  </Box>
);

export function SubmissionFilters({ f, set, onClear, hasFilters, types, locations, workers, contractorNames }) {
  return (
    <Flex gap="2.5" flexWrap="wrap" align="center" mb="5" bg={colors.white} border="1px solid"
      borderColor={colors.border} borderRadius="14px" p="4" data-testid="filters-bar">
      <Select value={f.type} onChange={set("type")} testId="filter-type">
        <option value="">All types</option>
        {types.map((t) => <option key={t} value={t}>{t}</option>)}
        <option value={ACK_TYPE}>Document acknowledgement</option>
        <option value={FORM_ASSIGN_TYPE}>Scheduled form (assigned)</option>
      </Select>
      <Select value={f.location} onChange={set("location")} testId="filter-location">
        <option value="">All locations</option>
        {locations.map((l) => <option key={l} value={l}>{l}</option>)}
      </Select>
      <Select value={f.worker} onChange={set("worker")} testId="filter-worker">
        <option value="">All employees</option>
        {workers.map((w) => <option key={w} value={w}>{w}</option>)}
      </Select>
      <Select value={f.status} onChange={set("status")} testId="filter-status">
        <option value="">All statuses</option>
        <option value="pending">Pending</option>
        <option value="logged">Logged</option>
        <option value="resolved">Resolved</option>
        <option value="superseded">Superseded</option>
        <option value="assigned">Assigned (scheduled)</option>
        <option value="awaiting_signatures">Awaiting signatures</option>
        <option value="completed">Completed (acknowledgement)</option>
        <option value="overdue">Overdue (scheduled)</option>
      </Select>
      <Select value={f.source} onChange={set("source")} testId="filter-source">
        <option value="">All sources</option>
        <option value="employee">Employees</option>
        <option value="portal">Contractor (QR portal)</option>
        <option value="signoff">Has contractor sign-off</option>
        <option value="any_contractor">Any contractor involvement</option>
      </Select>
      {contractorNames.length > 0 && (
        <Select value={f.contractor} onChange={set("contractor")} testId="filter-contractor">
          <option value="">All contractors</option>
          {contractorNames.map((c) => <option key={c} value={c}>{c}</option>)}
        </Select>
      )}
      <HStack gap="1.5" w={{ base: "full", sm: "auto" }} maxW="100%">
        <Input type="date" value={f.from} onChange={set("from")} data-testid="filter-from"
          h="40px" minW="0" flex={{ base: "1", sm: "0 0 auto" }} w={{ base: "auto", sm: "150px" }}
          borderRadius="8px" borderColor={colors.border} bg={colors.white} fontSize="sm" />
        <Text fontSize="xs" color={colors.textSecondary}>to</Text>
        <Input type="date" value={f.to} onChange={set("to")} data-testid="filter-to"
          h="40px" minW="0" flex={{ base: "1", sm: "0 0 auto" }} w={{ base: "auto", sm: "150px" }}
          borderRadius="8px" borderColor={colors.border} bg={colors.white} fontSize="sm" />
      </HStack>
      {hasFilters && (
        <Button size="sm" variant="ghost" onClick={onClear} data-testid="clear-filters-btn"><X size={14} /> Clear</Button>
      )}
    </Flex>
  );
}
